import { logoutReducer } from "../logout/logout.reducer";
import { overTimeReducer, OverTimeState, starReducer, StarState, tagChartReducer, TagsState } from '../usage-insights/usage.insights.reducers';
import { isRewardAllowedReducer, rewardLoadingReducer, UserRewardState, userRewardReducer } from '../user-rewards/user.rewards.reducers';
import { StatsState, statsReducer } from '../user-stats/user.stats.reducer';
import { RecentActivityState, recentActivityReducer } from '../notification/notification.reducer';
import { newsFeedLastUpdatedAtReducer, userBudgetReducer, UserBudgetState } from '../newsfeed/newfeed.reducers';
import { environment } from '../../../environments/environment';
import { ThankyouState, thankyouNotesReducer } from "../thankyou-notes/thankyou.notes.reducer";
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { TrendingTagsState, trendingTagsReducer } from '../trending-tags/trending.tags.reducer';
import { PopularSearchedState, PopularSearchedStateReducer } from '../filtering/popular.search.reducers';
import { TagSearchedState, tagSearchStateReducer } from '../filtering/tag.search.reducers';
import { recognitionRenderNormalReducer, RecognitionRenderNormalState } from '../recognition-render-normal/recognition.render.normal.reducers';
import { recognitionRenderFilterReducer, RecognitionRenderFilterState } from '../recognition-render-filter/recognition.render.filter.reducers';
import { companyValueReducer, CompanyValueState } from "../company-value/company.value.reducer";
import { businessGoalReducer, BusinessGoalState } from "../goals/business.goal.reducer";
import { rewardTagReducer, RewardTagState } from "../reward-tag/reward.tag.reducer";
import { surveyReducer, SurveyState } from "../survey/survey.reducer";
import { feedConfigReducer, ReactionDetailsInitialState } from "../reaction/reaction.reducer";
import { AccountReducer } from "../account/account.reducer";
import Account, { WalletConfig } from "../../modals/account";
import User from "../../modals/user";
import { UserReducer, configReducer } from "../user/user.reducer";
import { walletConfigReducer } from "../wallet-config/wallet.config.reducer";
import { exploreRewardReducer, ExploreRewardState } from "../../account/explore-rewards/explore.rewards.states";
import { leaderboardReducer, RnRewardLeaderboardYtdUserDtoState } from "../../account/leaderboard/leaderboard.states";
import { notificationBarDataReducer } from "../notification/notification-bar.reducer";
import { InotificationBar } from "../../modals/notificationBar";
import { SendRewardReducer } from "../send-reward/send-reward.reducer";
import { SendRewardType } from "../send-reward/send-reward.action";
import { IInsightDashboardFilter, insightDashboardFilterReducer } from "../insight-dashboard/insights-filters.reducer";
import { MarketplaceFilter } from "../../market-place/model/filter";
import { marketplaceFiltersReducer } from "../../market-place/store/reducers";
import { ICartLineItemReducer, miniCartDetailReducer } from "../mini-cart/mini-cart-details-reducer";

export interface AppState {
  stats: StatsState,
  recentActivity: RecentActivityState,
  userBudget: UserBudgetState,
  userRewards: UserRewardState
  rewardLoading: boolean,
  thanksYouNotes: ThankyouState,
  companyValue: CompanyValueState,
  businessGoal: BusinessGoalState,
  rewardTag: RewardTagState,
  overtime: OverTimeState
  stars: StarState,
  tagChart: TagsState,
  lastUpdatedAtNewsFeed: string;
  trendingTags: TrendingTagsState,
  popularSearch: PopularSearchedState,
  tagSearch: TagSearchedState,
  recognitionNormal: RecognitionRenderNormalState,
  recognitionFilter: RecognitionRenderFilterState,
  isRewardAllowed: boolean;
  surveyReducer: SurveyState,
  feedConfigReducer: ReactionDetailsInitialState,
  account: Account
  user: User,
  configLoading: boolean,
  walletConfig: WalletConfig,
  exploreReward: ExploreRewardState,
  leaderboard: RnRewardLeaderboardYtdUserDtoState,
  notificationBarData: InotificationBar,
  sendRewardType: SendRewardType
  insightsDashboardFilters: IInsightDashboardFilter,
  marketplaceFilter: MarketplaceFilter,
  miniCartDetails: ICartLineItemReducer
}

export const reducers: ActionReducerMap<AppState> = {
  user: UserReducer,
  account: AccountReducer,
  stats: statsReducer,
  recentActivity: recentActivityReducer,
  userBudget: userBudgetReducer,
  userRewards: userRewardReducer,
  rewardLoading: rewardLoadingReducer,
  thanksYouNotes: thankyouNotesReducer,
  companyValue: companyValueReducer,
  businessGoal: businessGoalReducer,
  rewardTag: rewardTagReducer,
  overtime: overTimeReducer,
  stars: starReducer,
  tagChart: tagChartReducer,
  lastUpdatedAtNewsFeed: newsFeedLastUpdatedAtReducer,
  trendingTags: trendingTagsReducer,
  popularSearch: PopularSearchedStateReducer,
  tagSearch: tagSearchStateReducer,
  recognitionNormal: recognitionRenderNormalReducer,
  recognitionFilter: recognitionRenderFilterReducer,
  isRewardAllowed: isRewardAllowedReducer,
  surveyReducer: surveyReducer,
  feedConfigReducer: feedConfigReducer,
  configLoading: configReducer,
  walletConfig: walletConfigReducer,
  exploreReward: exploreRewardReducer,
  leaderboard: leaderboardReducer,
  notificationBarData: notificationBarDataReducer,
  sendRewardType: SendRewardReducer,
  insightsDashboardFilters: insightDashboardFilterReducer,
  marketplaceFilter: marketplaceFiltersReducer,
  miniCartDetails : miniCartDetailReducer
};


export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [logoutReducer] : [];
